    <div class="form-group">
      <div class="row">
        <div class="col-4 d-flex flex-row align-items-center">
          <input [disabled]="disabled" id="input-days" class="form-control" [value]="timeSpanTextDays" [(ngModel)]="timeSpanTextDays" type="text" (change)="onTimeSpanChange(timeSpanTextDays)"/>
          <span class="ms-2">
            {{ 'DIALOGS.EDIT-MEMBERSHIP.FORM.DROPDOWN.DAYS' | translate }}
          </span>
          
        </div>
        <div class="col-4 d-flex flex-row align-items-center">
          <input [disabled]="disabled" id="input-hours" class="form-control" [value]="timeSpanTextHours" [(ngModel)]="timeSpanTextHours" type="text" (change)="onTimeSpanChange(timeSpanTextHours)"/>
          <span class="ms-2">
            {{ 'GENERIC.HOURS' | translate }}
          </span>
        </div>
        <div class="col-4 d-flex flex-row align-items-center">
          <input [disabled]="disabled" id="input-minutes" class="form-control" [value]="timeSpanTextMinutes" [(ngModel)]="timeSpanTextMinutes" type="text" (change)="onTimeSpanChange(timeSpanTextMinutes)"/>
          <span class="ms-2">
            {{ 'GENERIC.MINUTES' | translate}}
          </span>
          
        </div>
      </div>
    </div>